// store.js

import { configureStore } from "@reduxjs/toolkit";
import campaignReducer from "../features/campaignSlice.jsx";

export default configureStore({
  reducer: {
    campaign: campaignReducer,
  },
});
